<template>
    <div>
        <div class="breakouts shrinker">
            <div class="row">
                <div class="col-medium-1-4" v-for="timeslot in timeslots">
                    <div class="timeslot-card" v-on:click="setTimeslot(timeslot)" v-bind:class="{'timeslot-card--workshop': timeslot.type == 'workshop', 'timeslot-card--breakout': timeslot.type == 'breakout'}">
                        <div class="timeslot-card__name">
                            {{ timeslot.name }}
                        </div>
                        <div class="timeslot-card__time">
                            {{ timeTopLine(timeslot) }}
                            <br>
                            {{ timeBottomLine(timeslot) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import axios from 'axios'
    import dateFormat from 'dateformat'
    import ScheduleSwitcher from './ScheduleSwitcher.vue'
    import transitionToFromAuto from 'transition-to-from-auto'

    export default {

        components: {
            ScheduleSwitcher
        },

        data: function() {
            return {
                timeslot: null
            }
        },

        props: [
            'breakoutTracks',
            'sessions',
            'speakers',
            'timeslots'
        ],

        methods: {
            getOrangeDate: function(date) {
                var dateParts = date.split(" ");
                var dayParts = dateParts[0].split('-');
                var timeParts = dateParts[1].split(':');

                return new Date(dayParts[0], dayParts[1], dayParts[2], timeParts[0], timeParts[1], timeParts[2]);
            },

            timeTopLine: function(timeslot) {
                return dateFormat(this.getOrangeDate(timeslot.startTime), 'dddd mm.dd');
            },

            timeBottomLine: function(timeslot) {
                return dateFormat(this.getOrangeDate(timeslot.startTime), 'h:MM') + ' - ' + dateFormat(this.getOrangeDate(timeslot.endTime), 'h:MM');
            },

            setTimeslot: function(timeslot) {
                this.timeslot = timeslot;
                this.$parent.currentModalComponent = 'ScheduleModal';
                this.$parent.modalArguments = {
                    scheduleSwitcherView: 'timeslot',
                    timeslots: this.timeslots,
                    sessions: this.sessions,
                    speakers: this.speakers,
                    breakoutTracks: this.breakoutTracks,
                    timeslot: this.timeslot
                };
                this.$parent.showModal = true;
                document.body.classList.add("modal-open");
            }
        },

        created: function() {

        },

        watch: {
            sessions: function(sessions) {

            }
        }


    }
</script>


// WEBPACK FOOTER //
// Timeslots.vue?16760974